export default __webpack_public_path__ + "static/media/fr-asia-1.bfa66437.jpg";